import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api.ts';
import { useSesion } from '../lib/sesion.ts';

export type SeccionBanner = 'inicio_h' | 'inicio_v' | 'plantillas_h' | 'productos_h' | 'galeria_h';

interface Banner {
  campaniaId: string;
  imagenUrl: string;
  ctaUrl: string | null;
}

/**
 * Banner publicitario de campaña para una sección. Si no hay campaña activa
 * con banner en esa sección, no rinde NADA: la sección no existe ni ocupa espacio.
 */
export function BannerCampania({ seccion, className = '' }: { seccion: SeccionBanner; className?: string }) {
  const { data: sesion } = useSesion();
  const consulta = useQuery({
    queryKey: ['campania-banner', seccion],
    queryFn: () => api<{ banner: Banner | null }>(`/campanias/banners?seccion=${seccion}`),
    enabled: Boolean(sesion?.cliente),
    staleTime: 5 * 60_000,
  });

  const banner = consulta.data?.banner;
  if (!banner) return null;

  const imagen = (
    <img
      src={banner.imagenUrl}
      alt=""
      className={seccion === 'inicio_v' ? 'h-full w-full object-cover' : 'w-full object-cover'}
    />
  );

  if (banner.ctaUrl) {
    return (
      <a
        href={banner.ctaUrl}
        target="_blank"
        rel="noopener noreferrer"
        className={`tarjeta block overflow-hidden transition hover:-translate-y-0.5 hover:shadow-[var(--sombra-alta)] ${className}`}
      >
        {imagen}
      </a>
    );
  }
  return <div className={`tarjeta overflow-hidden ${className}`}>{imagen}</div>;
}
